import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';
import { buildProcessingFactoryWritePayload } from '#/api/momMgmt/settings/processingFactory/serializeProcessingFactoryWrite';

export async function createProcessingFactory(values) {
  const { data: raw } = await request.post(
    '/mom/processing-factory',
    keysToSnake(buildProcessingFactoryWritePayload(values)),
  );
  return parseVer4DetailResponse(raw);
}
